import BlogLeftListContainer from "../../../../components/pages/blog/blogPage/BlogLeftList";

const BlogLeftList = () => {
  return <BlogLeftListContainer />;
};

export default BlogLeftList;
